module.exports = __webpack_public_path__ + "img/alabama-trucking.e19bd2ed.jpg";